import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import Container from 'components/Container'
import AvailablePlans, { CustomPricing } from 'components/Plans'
import { StaticImage } from 'gatsby-plugin-image'
import { DEFAULT_DARK_CONTRAST_COLOR } from 'services/color'

interface PlansProps {
  customPricingOptions?: CustomPricing[]
  abVariation?: 'a' | 'b'
  redirectToTarget?: boolean
  offerPlan?: boolean
  offerDiscount?: number
}

export const Plans = ({ customPricingOptions, abVariation = 'a', redirectToTarget, offerPlan, offerDiscount }: PlansProps) => {
  const { strapiGlobal } = useStaticQuery(graphql`
    query {
      strapiGlobal {
        ...PlansInfo
      }
    }
  `)

  const { pricing } = strapiGlobal as Queries.PlansInfoFragment

  const componentToRender = {
    a: (
      <div id='planos' style={{ display: 'grid' }}>
        <StaticImage
          className='row-start-1 col-start-1 lg:max-h-[2200px] xl:max-h-[1590px]'
          layout='fullWidth'
          alt=''
          src='../../images/grey-bg.png'
        />
        <div style={{ gridArea: '1/1', position: 'relative', placeItems: 'center', display: 'grid' }}>
          <Container className='flex flex-col gap-8 py-12 xl:py-20 text-white'>
            <div className='flex flex-col gap-4 text-center xl:text-left xl:w-2/3'>
              <h3 className='text-primary-600 font-semibold text-2xl'>Nossos planos</h3>
              <p>
                Oferecemos serviços para todas as regiões do Brasil. Escolha a opção que mais se adequa às suas necessidades ou solicite um
                plano personalizado.
              </p>
            </div>

            <AvailablePlans
              pricing={pricing}
              customPricingOptions={customPricingOptions}
              secondaryColor={DEFAULT_DARK_CONTRAST_COLOR}
              planCardOptions={{
                blurred: true,
              }}
              redirectToTarget={redirectToTarget}
              offerPlan={offerPlan}
              offerDiscount={offerDiscount}
            />
          </Container>
        </div>
      </div>
    ),
    b: (
      <div id='planos' style={{ display: 'grid' }}>
        <div style={{ gridArea: '1/1', position: 'relative', placeItems: 'center', display: 'grid' }} className='bg-black/70'>
          <Container className='flex flex-col gap-8 py-12 xl:py-20 text-white'>
            <div className='flex flex-col gap-4 text-center xl:text-left xl:w-2/3'>
              <h3 className='text-primary-600 font-semibold text-2xl'>Nossos planos</h3>
              <p>
                Oferecemos serviços para todas as regiões do Brasil. Escolha a opção que mais se adequa às suas necessidades ou solicite um
                plano personalizado.
              </p>
            </div>

            <AvailablePlans
              pricing={pricing}
              customPricingOptions={customPricingOptions}
              secondaryColor={DEFAULT_DARK_CONTRAST_COLOR}
              planCardOptions={{
                blurred: true,
              }}
              redirectToTarget={redirectToTarget}
              offerPlan={offerPlan}
              offerDiscount={offerDiscount}
            />
          </Container>
        </div>
      </div>
    ),
  }

  return componentToRender[abVariation]
}

export const query = graphql`
  fragment GlobalPlansContent on STRAPI__COMPONENT_PRICING_PLAN_PRICE {
    id
    valueFrom
    value
    monthly
    # highlightChipText
  }

  fragment GlobalPricingInfo on STRAPI_GLOBAL {
    pricing {
      id
      meiCommerce {
        ...GlobalPlansContent
      }
      meiService {
        ...GlobalPlansContent
      }
      simplesNacionalCommerce {
        ...GlobalPlansContent
      }
      simplesNacionalService {
        ...GlobalPlansContent
      }
      lucroPresumidoCommerce {
        ...GlobalPlansContent
      }
      lucroPresumidoService {
        ...GlobalPlansContent
      }
      lucroRealCommerce {
        ...GlobalPlansContent
      }
      lucroRealService {
        ...GlobalPlansContent
      }
      digitalCertificate {
        ...GlobalPlansContent
      }
    }
  }

  fragment PlansInfo on STRAPI_GLOBAL {
    id
    ...GlobalPricingInfo
  }
`

export default Plans
